import React, { useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../images/services-usa/android-new/bg_android_banner.webp";
import GIF from "../../images/services-usa/android-new/pure_banner.gif";

function Banner(props) {
  return (
    <div
      className="service_usa web_dev_service healthcare_banner android_banner no-bread-banner"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={7} lg={6} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <h1 className="web_head_banner" style={{ marginBottom: "10px" }}>
                Android App Development Company
              </h1>
              <span>
                Build User-centric Apps with Full-fledged Customization
              </span>
              <p>
                From concept to code, we create rich-featured Android
                applications with consistent performance and premium
                functionality. As a trusted Android app development company, we
                facilitate multiple industries, covering diverse services
                through app design, development, QA, and maintenance.
                Integrating the right USP, our clients gain a 2X progressive ROI
                growth.
              </p>

              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Lets Build Your Android App
              </Link>
              {/* <Link
                to="/app-cost-calculator"
                className="border_btn web_case_btn"
                aria-label="TekRevol Contact"
              >
                Calculate App Cost
              </Link> */}
            </div>
          </Col>
          <Col
            xs={12}
            md={5}
            lg={6}
            xl={5}
            xxl={5}
            className="my-auto text-center"
          >
            <div className="health_banner_img">
              {/* <StaticImage
                src="../../images/services-usa/android-new/banner_android_img_1.webp"
                alt="tekrevol_web"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={588}
                height={712}
              /> */}
              <img src={GIF} alt="TekRevol" />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
